import {Component, Input, OnInit} from '@angular/core';
import {HttpService} from '../../../services/http.service';
import {Filter} from '../../../models/warranties/filter.model';
import {Warranty} from '../../../models/warranties/warranty.model';
import {Dealer} from '../../../models/dealers/dealer.model';
import {AuthService} from '../../../auth/auth.service';
import {Market} from '../../../models/dealers/market.enum';
import {I18nPipe} from '../../../services/i18n.pipe';
import {CreditNote} from '../../../models/warranties/credit-note.model';
import {DecimalUtil} from '../../commons/util/decimal-util';

@Component({
  selector: 'app-warranty-summary',
  templateUrl: './warranty-summary.component.html',
  styleUrls: ['./warranty-summary.component.scss']
})
export class WarrantySummaryComponent implements OnInit {
  beluxDealer = 'BMW Group Belux';
  deliveringAgentNumber = '05668';
  constructor(private authService: AuthService, private i18nPipe: I18nPipe, private http: HttpService) {
  }

  @Input() warranty: Warranty = new Warranty();
  @Input() question1: string;
  @Input() question2: string;
  @Input() editable: boolean;
  @Input() hasCreditNote: boolean;
  @Input() dealers: Array<Dealer>;
  @Input() creditNote: CreditNote = new CreditNote();

  user: string;
  userName: string;
  role: string;
  dealer: string;
  company: string;
  filter: Filter = new Filter();

  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
    this.role = sessionStorage.getItem('role');
    this.dealer = sessionStorage.getItem('dealer');
    this.company = sessionStorage.getItem('company');
  }

  getBooleanString(bool: boolean) {
    if (bool) {
      return 'YES';
    } else {
      return 'NO';
    }
  }

  amount(amount: number): boolean {
    return !!(amount || amount === 0);
  }

  isNL() {
    return this.authService.market() === Market.NL;
  }

  firstDayOfNextMonthDate(fromDate: Date): Date {
    const result = new Date(fromDate);
    result.setMonth(result.getMonth() + 1);
    return new Date(result.getFullYear(), result.getMonth(), 1);
  }

  keepDecimalTrailingZero(val: any){
    return this.isValNull(val) ? `` : `EUR ${DecimalUtil.enforceDecimals(val)}`;
  }

  isValNull(val: any){
    return val === null;
  }

}
